import { IHistoryItem } from '@/framework';
import { Framework } from '@/framework/instance';
import { IExportPlugin, PluginType } from '@/version-types';

const HISTORY_TYPE = 'template-name';

interface IHistoryData {
    oldName: string;
    newName: string;
}

/** 模板历史记录 */
export class TemplateHistory extends Framework {
    constructor(id: string) {
        super(id);
        this.registerChangeTemplateName();
    }

    /** 注册模板名称变化 */
    private registerChangeTemplateName() {
        this.framework.history.register(HISTORY_TYPE, {
            onRedoUndo: (historyItem: IHistoryItem<IHistoryData>, isRedo: boolean, isUndo: boolean) => {
                const { oldName, newName } = historyItem.data.data;
                if (isUndo) {
                    this.framework.getInstance(Template).setName(oldName);
                }
                if (isRedo) {
                    this.framework.getInstance(Template).setName(newName);
                }
            },
            onAfterWrite: (historyItem: IHistoryItem<IHistoryData>) => {
                const { newName } = historyItem.data.data;
                return {
                    message: [newName],
                };
            },
            onAfterRedoUndo: (historyItem: IHistoryItem<IHistoryData>, isRedo) => {
                const { oldName, newName } = historyItem.data.data;
                return {
                    message: [isRedo ? newName : oldName],
                };
            },
            onMessage: (message: [string]) => {
                const [name] = message;
                this.framework.getInstance(Template).setName(name);
            },
        });
    }
}

/** 模板 */
export class Template extends Framework {
    private eventName = 'gs-template-name';

    /** 设置模板名称 */
    setName(templateName: string) {
        this.framework.events.emit(this.eventName, templateName);
    }

    /** 监听模板名称变化 */
    onChange(fn: (name: string) => void) {
        return this.framework.events.on(this.eventName, fn);
    }

    /** 写入历史记录 */
    write(oldName: string, newName: string) {
        this.setName(newName);

        this.framework.history.write({
            type: HISTORY_TYPE,
            data: {
                oldName,
                newName,
            },
        });
    }
}

/**
 * 模板插件扩展
 */
export const templateExtension: IExportPlugin = {
    sort: 0,
    type: PluginType.EXTENSION,
    name: 'template-extension',
    createInstance({ identity }) {
        return [{ key: 'Template', value: new Template(identity) }];
    },
    createHistory({ identity }) {
        return [new TemplateHistory(identity)];
    },
};
